class UASniffer {
	constructor(opts = {}) {
		this.ua = opts.ua || window.navigator.userAgent;
		this.platform = opts.platform || window.navigator.platform;
	}

	getBrowserInfo() {
		const matchStr = {
			ie: /msie [0-9.]+/,
			ieAlt: /rv:[0-9.]+/,
			edge: /edge\/[0-9.]+/,
			safari: /version\/[0-9.]+/,
			chrome: /chrome\/[0-9.]+/,
			firefox: /firefox\/[0-9.]+/,
			chromeiOS: /crios\/[0-9.]+/,
			firefoxiOS: /fxios\/[0-9.]+/
		};

		const browserInfo = {
			name: '',
			versionString: '',
			version: {
				major: 0,
				minor: 0
			}
		};

		const ua = this.ua.toLowerCase();

		// check for Webkit (Chrome & Safari)
		if (ua.indexOf('webkit') !== -1) {
			if (ua.match(matchStr.chrome)) {
				browserInfo.name = 'chrome';

				browserInfo.versionString = ua.match(matchStr.chrome).toString().replace(/chrome\//, '');
			} else if (ua.match(matchStr.safari)) {
				browserInfo.name = 'safari';

				browserInfo.versionString = ua.match(matchStr.safari).toString().replace(/version\//, '');
			}
		}

		// check for Chrome on iOS
		if (ua.indexOf('crios') !== -1) {
			browserInfo.name = 'chrome-ios';

			if (ua.match(matchStr.chromeiOS)) {
				browserInfo.versionString = ua.match(matchStr.chromeiOS).toString().replace(/crios\//, '');
			}
		}

		// check for Firefox
		if (ua.indexOf('firefox') !== -1) {
			browserInfo.name = 'firefox';

			if (ua.match(matchStr.firefox)) {
				browserInfo.versionString = ua.match(matchStr.firefox).toString().replace(/firefox\//, '');
			}
		}

		// check for Firefox on iOS
		if (ua.indexOf('fxios') !== -1) {
			browserInfo.name = 'firefox-ios';

			if (ua.match(matchStr.firefoxiOS)) {
				browserInfo.versionString = ua.match(matchStr.firefoxiOS).toString().replace(/fxios\//, '');
			}
		}

		// check for IE
		if (ua.indexOf('trident') !== -1) {
			browserInfo.name = 'ie';

			if (ua.match(matchStr.ieAlt)) {
				// sometimes IE11 doesn't use MSIE, so look for 'rv:' instead
				browserInfo.versionString = ua.match(matchStr.ieAlt).toString().replace(/rv:/, '');
			} else if (ua.match(matchStr.ie)) {
				// check for MSIE identifier
				browserInfo.versionString = ua.match(matchStr.ie).toString().replace('msie ', '');
			}
		}

		// check for Edge
		if (ua.indexOf('edge/') !== -1) {
			browserInfo.name = 'edge';

			if (ua.match(matchStr.edge)) {
				browserInfo.versionString = ua.match(matchStr.edge).toString().replace(/edge\//, '');
			}
		}

		if (browserInfo.versionString) {
			var parts = browserInfo.versionString.split('.');

			browserInfo.version.major = parts[0] !== undefined ? parts[0] : 0;
			browserInfo.version.minor = parts[1] !== undefined ? parts[1] : 0;
		}

		return browserInfo;
	}

	getOSInfo() {
		const osInfo = {
			name: '',
			versionString: '',
			versionClass: '',
			version: {
				major: 0,
				minor: 0
			}
		};

		let verStrReplace = '';
		let uaMatch = false;

		const platform = this.platform.toLowerCase();


		if (platform.search('linux') >= 0) {
			osInfo.name = 'linux';

			uaMatch = this.ua.match(/Android (\d+).(\d+)/);

			if (uaMatch) {
				osInfo.name = 'android';
				verStrReplace = 'Android ';
			}
		}

		if (platform.search('win') >= 0) {
			osInfo.name = 'win';

			// TODO: add windows version numbers
		}

		if (platform.search('mac') >= 0) {
			osInfo.name = 'osx';

			uaMatch = this.ua.match(/OS X (\d+).(\d+)/);

			if (uaMatch) {
				verStrReplace = 'OS X ';
			}
		}

		if (platform.search('iphone') >= 0 || platform.search('ipad') >= 0) {
			osInfo.name = 'ios';

			uaMatch = this.ua.match(/OS (\d+).(\d+)/);

			if (uaMatch) {
				verStrReplace = 'OS ';
			}
		}

		if (uaMatch) {
			osInfo.versionString = (uaMatch && verStrReplace) ? uaMatch[0].toString().replace(verStrReplace, '') : '';
			osInfo.version.major = (uaMatch.length >= 2) ? uaMatch[1] : '';
			osInfo.version.minor = (uaMatch.length >= 3) ? uaMatch[2] : '';
		}


		return osInfo;
	}

	getBrowserClasses() {
		const bi = this.getBrowserInfo();

		return [
			`browser-${bi.name}`,
			`browser-${bi.name}-${bi.version.major}`
		];
	}

	getOSClasses() {
		const osInfo = this.getOSInfo();
		const classes = [];

		if (!osInfo.name) {
			return classes;
		}

		classes.push(`os-${osInfo.name}`);

		if (osInfo.version.major) {
			classes.push(`os-${osInfo.name}-${osInfo.version.major}`);
		}

		if (osInfo.version.major && osInfo.version.minor) {
			classes.push(`os-${osInfo.name}-${osInfo.version.major}-${osInfo.version.minor}`);
		}

		return classes;
	}
}

export default UASniffer;
